export default function injectSource(url, id) {
  const fileref = document.createElement('script')

  if (document.getElementById(id)) {
    return null
  }

  fileref.setAttribute('type', 'text/javascript')
  fileref.setAttribute('async', '')
  fileref.setAttribute('defer', '')
  fileref.setAttribute('src', url)
  fileref.id = id

  return document.body.appendChild(fileref)
}
